<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Aloqa uchun</h2>
        <div class="header-actions">
          <div class="search-wrapper">
            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <button class="refresh-btn" @click="Data()" title="Yangilash">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
          </button>

          <button class="add-btn" @click="openModal()">
            + Qo'shish
          </button>
          <top></top>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 50px">№</th>
                <th>{{ $t("TELEFON") }}</th>
                <th>{{ $t("TELEGRAM") }}</th>
                <th>{{ $t("INSTAGRAM") }}</th>
                <th style="width: 100px; text-align: center;">{{ $t("AMAL") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedItems" :key="item.id">
                <td>{{ (currentPage - 1) * $store.state.countindex + index + 1 }}</td>
                <td class="font-bold text-purple">
                  {{ item.phone_number }}
                </td>
                <td>
                  <a v-if="item.telegram" :href="item.telegram" target="_blank" class="social-tag tg">
                    {{ getUsername(item.telegram) }}
                  </a>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td>
                  <a v-if="item.instagram" :href="item.instagram" target="_blank" class="social-tag ig">
                    {{ getUsername(item.instagram) }}
                  </a>
                  <span v-else class="text-muted small">—</span>
                </td>
                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click="openModal(item)" title="Tahrirlash">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                    </button>
                    <button class="icon-btn del" @click="Trash(item.id)" title="O'chirish">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredItems.length === 0">
                <td colspan="5" class="empty-row">Ma'lumot topilmadi</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div class="info">
            {{ totalRows }} {{ $t('ta listdan') }}
            {{ Math.min(currentPage * $store.state.countindex, totalRows) }} {{ $t('tasi') }}
          </div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="$store.state.countindex" size="sm"
            class="my-0 custom-pagination"></b-pagination>
        </div>
      </div>
    </div>

    <!-- MA'LUMOT QO'SHISH/TAHRIRLASH MODALI -->
    <b-modal id="modal-form" :title="isEdit ? 'Tahrirlash' : 'Yangi Kontakt'" hide-footer centered v-model="showModal">
      <form @submit.prevent="saveData">
        <div class="form-group mb-3">
          <label class="modern-label">{{ $t("Telefon raqam") }}</label>
          <input v-model="form.phone_number" type="text" class="modern-input" required>
        </div>
        <div class="form-group mb-3">
          <label class="modern-label">{{ $t("Telegram Link") }}</label>
          <input v-model="form.telegram" type="text" class="modern-input">
        </div>
        <div class="form-group mb-4">
          <label class="modern-label">{{ $t("Instagram Link") }}</label>
          <input v-model="form.instagram" type="text" class="modern-input">
        </div>

        <div class="modal-btns">
          <button type="button" class="m-btn cancel" @click="showModal = false">YO'Q</button>
          <button type="submit" class="m-btn confirm">SAQLASH</button>
        </div>
      </form>
    </b-modal>

    <!-- O'CHIRISHNI TASDIQLASH MODALI -->
    <b-modal id="modal-delete" hide-footer centered no-stacking>
      <div class="text-center p-3">
        <div class="warning-icon mb-3">!</div>
        <h3 class="fw-bold mb-2">O'chirishni tasdiqlaysizmi?</h3>
        <p class="text-muted mb-4">Ushbu amalni ortga qaytarib bo'lmaydi.</p>
        <div class="modal-btns">
          <button class="m-btn cancel" @click="$bvModal.hide('modal-delete')">BEKOR QILISH</button>
          <button class="m-btn confirm bg-danger" @click="confirmDelete">HA, O'CHIRILSIN</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Top from "../../Layout/Top.vue";

export default {
  components: { Top },
  data() {
    return {
      items: [],
      filter: "",
      totalRows: 0,
      currentPage: 1,
      showModal: false,
      isEdit: false,
      selectedId: null, // O'chirish uchun ID saqlaydi
      form: { id: null, phone_number: "+998", telegram: "", instagram: "" },
      api: {
        all: "api/v1/contact/all",
        create: "api/v1/contact/",
        update: "api/v1/contact/id/",
        delete: "api/v1/contact/id/"
      }
    };
  },
  computed: {
    filteredItems() {
      if (!this.filter) return this.items;
      const s = this.filter.toLowerCase();
      return this.items.filter(i => i.phone_number.toLowerCase().includes(s));
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.$store.state.countindex;
      return this.filteredItems.slice(start, start + this.$store.state.countindex);
    }
  },
  watch: {
    filter() {
      this.currentPage = 1;
      this.totalRows = this.filteredItems.length;
    }
  },
  created() {
    this.Data();
  },
  methods: {
    getUsername(url) {
      if (!url) return "";
      let parts = url.replace(/\/$/, "").split("/");
      return parts[parts.length - 1];
    },
    Data() {
      axios.get(this.api.all).then(res => {
        this.items = res.data;
        this.totalRows = this.items.length;
      });
    },
    openModal(item = null) {
      if (item) {
        this.isEdit = true;
        this.form = { ...item };
      } else {
        this.isEdit = false;
        this.form = { id: null, phone_number: "+998", telegram: "https://t.me/", instagram: "https://www.instagram.com/" };
      }
      this.showModal = true;
    },
    saveData() {
      const method = this.isEdit ? "patch" : "post";
      const url = this.isEdit ? this.api.update + this.form.id : this.api.create;
      axios[method](url, this.form).then(() => {
        this.showModal = false;
        this.Data();
      });
    },
    // O'chirish tugmasi bosilganda
    Trash(id) {
      this.selectedId = id;
      this.$bvModal.show('modal-delete');
    },
    // Modalda tasdiqlanganda
    confirmDelete() {
      axios.delete(this.api.delete + this.selectedId).then(() => {
        this.$bvModal.hide('modal-delete');
        this.Data();
      });
    }
  }
};
</script>

<style scoped>
/* ASOSIY SAHIFA */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* SEARCH */
.search-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #94a3b8;
}

.modern-search {
  padding: 8px 10px 8px 35px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  outline: none;
  font-size: 14px;
}

/* JADVAL */
.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table th {
  text-align: left;
  padding: 15px;
  color: #94a3b8;
  font-size: 11px;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  background: white;
  position: sticky;
  top: 0;
  z-index: 10;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #f8fafc;
  font-size: 14px;
  color: #334155;
  vertical-align: middle;
}

/* ICON BUTTONS */
.actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
}

.icon-btn:hover {
  transform: scale(1.1);
}

.edit {
  background-color: #eff6ff;
  color: #2563eb;
}

.del {
  background-color: #fff1f2;
  color: #e11d48;
}

/* SOCIAL TAGS */
.social-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.tg {
  background: #eff6ff;
  color: #2563eb;
}

.ig {
  background: #fdf2f8;
  color: #be185d;
}

.text-purple {
  color: #a142f4;
  font-weight: 700;
}

/* MODAL & PAGINATION */
.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel {
  background: #f1f5f9;
  color: #64748b;
  margin-right: 10px;
}

.confirm {
  background: #a142f4;
  color: white;
}

/* Delete Modal Warning Icon */
.warning-icon {
  width: 60px;
  height: 60px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
}

.modal-btns {
  display: flex;
  margin-top: 20px;
}

.modern-label {
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 5px;
  display: block;
}

.modern-input {
  width: 100%;
  border-radius: 12px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  outline: none;
}

.add-btn {
  background: #a142f4;
  color: white;
  border: none;
  height: 35px;
  padding: 0 15px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #94a3b8;
  width: 35px;
  height: 35px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
}

.info {
  color: #94a3b8;
  font-size: 13px;
}
</style>